export function getRotinaFisica(valor: number): string {
    const opcoes = [
        { bit: 1, texto: 'Sedentária' },
        { bit: 2, texto: 'Musculação' },
        { bit: 4, texto: 'Pilates' },
        { bit: 8, texto: 'Fisioterapia' },
        { bit: 16, texto: 'Outros' },
    ];
    return opcoes.filter(op => valor & op.bit).map(op => op.texto).join(', ');
}

export function getTempoSedentaria(valor: number): string {
    const map: Record<number, string> = {
        1: 'Sedentária',
        2: 'Faço Musculação',
        3: 'Faço Pilates',
    };
    return map[valor] || 'Não informado';
}

export function getFraseHoje(valor: number): string {
    const map: Record<number, string> = {
        1: 'Tô tentando sair do zero',
        2: 'Já comecei outras vezes, mas nunca fui constante',
        3: 'Já treino, mas quero algo que me desafie e motive mais',
    };
    return map[valor] || 'Não informado';
}

export function getDificuldadePrincipal(valor: number): string {
    const opcoes = [
        { bit: 1, texto: 'Falta de tempo' },
        { bit: 2, texto: 'Falta de motivação' },
        { bit: 4, texto: 'Me sinto sozinha nesse processo' },
        { bit: 8, texto: 'Já tentei e me frustrei' },
        { bit: 16, texto: 'Não sei por onde começar' },
        { bit: 32, texto: 'Outra' },
    ];
    return opcoes.filter(op => valor & op.bit).map(op => op.texto).join(', ');
}

export function getPerfilTipo(valor: number): string {
    const map: Record<number, string> = {
        1: 'Introvertida / tímida / mais reservada',
        2: 'Extrovertida / comunicativa / mais sociável',
    };
    return map[valor] || 'Não informado';
}

export function getExecucaoTipo(valor: number): string {
    const map: Record<number, string> = {
        1: 'Mais independente para executar tarefas',
        2: 'Mais dependente, um pouco insegura',
    };
    return map[valor] || 'Não informado';
}

export function getAprendizadoTipo(valor: number): string {
    const map: Record<number, string> = {
        1: 'Sentindo no corpo (tato)',
        2: 'Vendo como se faz (visual)',
        3: 'Ouvindo instruções (auditiva)',
    };
    return map[valor] || 'Não informado';
}

export function getSintomasPrincipais(valor: number): string {
    const opcoes = [
        { bit: 1, texto: 'Tontura' },
        { bit: 2, texto: 'Desmaios' },
        { bit: 4, texto: 'Escurecimento da visão' },
        { bit: 8, texto: 'Dor no peito' },
        { bit: 16, texto: 'Taquicardia' },
        { bit: 32, texto: 'Falta de ar' },
        { bit: 64, texto: 'Nenhum' },
    ];
    return opcoes.filter(op => valor & op.bit).map(op => op.texto).join(', ');
}

export function getFormatoTreino(valor: number): string {
    const map: Record<number, string> = {
        1: 'Presencial',
        2: 'Online',
        3: 'Ambos',
        4: 'Outro',
    };
    return map[valor] || 'Não informado';
}
